import React, {FC, HTMLAttributes} from "react"
import styled from "styled-components"

import {CommonProps, commonCSS} from "../common"

import {SpacingProps, SizingProps} from "../../global/css"
import {mainStyles, h1, h2, h3, h4, h5, h6} from "./styles"

export interface HeadingProps
  extends CommonProps,
    SpacingProps,
    SizingProps,
    HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement | HTMLSpanElement> {
  as?: "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "strong"
  children: string | ReactNode
  id?: string
}

const H1Style = styled.h1`
  ${mainStyles}
  ${commonCSS}
  ${h1}
`

const H2Style = styled.h2`
  ${mainStyles}
  ${commonCSS}
  ${h2}
`

const H3Style = styled.h3`
  ${mainStyles}
  ${commonCSS}
  ${h3}
`

const H4Style = styled.h4`
  ${mainStyles}
  ${commonCSS}
  ${h4}
`

const H5Style = styled.h5`
  ${mainStyles}
  ${commonCSS}
  ${h5}
`

const H6Style = styled.h6`
  ${mainStyles}
  ${commonCSS}
  ${h6}
`

export const H1: FC<HeadingProps> = ({children, ...props}) => <H1Style {...props}>{children}</H1Style>
export const H2: FC<HeadingProps> = ({children, ...props}) => <H2Style {...props}>{children}</H2Style>
export const H3: FC<HeadingProps> = ({children, ...props}) => <H3Style {...props}>{children}</H3Style>
export const H4: FC<HeadingProps> = ({children, ...props}) => <H4Style {...props}>{children}</H4Style>
export const H5: FC<HeadingProps> = ({children, ...props}) => <H5Style {...props}>{children}</H5Style>
export const H6: FC<HeadingProps> = ({children, ...props}) => <H6Style {...props}>{children}</H6Style>
